// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUserCheck, IconBasket, IconMessages, 
    IconLayoutKanban, IconMail, IconCalendar, 
    IconNfc,
    IconLetterA,
    IconBookmark,
    IconReport
} from "@tabler/icons-react"

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const pointsEnregistrements = {
    id: 'enregistrement_des_points1',
    title: ["L. ", <FormattedMessage id="enregistrement_des_points" />],
    type: 'group',
    icon: <IconReport />, // Use a valid icon component here
   /*  children: [
        {
                    id: "collapse1",
                    title: <FormattedMessage id="collapse" />,
                    type: "collapse",
                    icon: IconBookmark, */
                    children: [

                        {
                            id: 'avaliations_realise1',
                            title: ["1. ", <FormattedMessage id="avaliations_realise" />],
                            type: 'item',
                            url: '/formules/TypoExamesEAvaliations'
                        },

                     {
                            id: 'caklendario_lancamento_notas1',
                            title: ["2. ",  <FormattedMessage id="calendario_lancamento_notas" />],
                            type: 'item',
                            url: '/formules/CalendarExame'
                        }, 
                       
                        {
                            id: 'lista_presence_digital1',
                            title: ["3. ", <FormattedMessage id="lista_presence_digital" />],
                            type: 'item',
                            url:  '/notas/ListaPreseneDigital'
                        },

                       /*  {
                            id: 'lancamento_notas_estudante1',
                            title: ["4. ", <FormattedMessage id="lancamento_notas_estudante" />],
                            type: 'item',
                            url:  '/notas/ReleveCoteImpressionAdministracao'
                        }, */

                            {
                                id: 'LancerPointInterrogrationAntesExame1',
                                title: ["4. ", <FormattedMessage id="LancerPointInterrogrationAntesExame" />],
                                type: 'item',
                                url:  '/notas/LancerPointInterrogrationAntesExame'
                            },
                        
                        {
                            id: 'lancerpoint_premiereSession1',
                            title: ["5. ", <FormattedMessage id="Lancamento_nnotas_exame" />],
                            type: 'item',
                            url: '/notas/LancerPointInterrogrationTP'
                        },
                        {
                            id: 'lancerpoint_deuxiemeSession1',
                            title: ["6. ", <FormattedMessage id="lancerpoint_deuxiemeSession" />],
                            type: 'item',
                            url: '/notas/LancerPointSession2'
                        },

                        {
                            id: 'lancamento_notas_xame_espcial1',
                            title: ["7. ", <FormattedMessage id="lancamento_notas_xame_espcial" />],
                            type: 'item',
                            url: '/notas/LancerPointExamenSpecial'
                        },

                        {
                            id: 'lancerpoint_Stage1',
                            title: ["8. ", <FormattedMessage id="lancerpoint_Stage1" />],
                            type: 'item',
                            url: '/notas/LancerPointStage'
                            // '/user/social-profile/posts'
                        },
                        
                        {
                            id: 'lancerpoint_memoire1',
                            title: ["9. ", <FormattedMessage id="lancerpoint_memoire" />],
                            type: 'item',
                            url: '/notas/LancerMemoire'
                            // '/user/social-profile/posts'
                        },

                        {
                            id: 'notas_atribuida1',
                            title: ["10. ",  <FormattedMessage id="notas_atribuida" />],
                            type: 'item',
                            url: '/notas/LancerPointInterrogrationTPNotasAtribuidas'
                        },

                        {
                            id: 'notas_formulas_execucao_geral1',
                            title: ["11. ", <FormattedMessage id="notas_formulas_execucao_geral" />],
                            type: 'item',
                            url: '/notas/NotasCalculosGeralExecucao'
                        },
                       
                        {
                            id: 'controle_enregistrement_point1',
                            title: ["12. ", <FormattedMessage id="controle_enregistrement_point1" />],
                            type: 'item',
                            url: '/notas/ControleEnrefistremenrtPoints'
                        },

                        {
                            id: 'audit_enregistrement_points1',
                            title: ["13. ", <FormattedMessage id="audit_enregistrement_points" />],
                            type: 'item',
                            url: '/notas/ControleEnrefistremenrtPointsPorCurso'
                        },
                    ],
             //     },
     //   ]
        
};

export default pointsEnregistrements;
